export enum ProfileType {
  BUSINESS = 'BUSINESS',
  PERSONAL = 'PERSONAL',
}

export type ProfileTypeBusiness = 'BUSINESS';
export type ProfileTypePersonal = 'PERSONAL';
